<div class="abstract-modal-container pt-popup-container" [ngClass]="[containerClasses, !active ? 'hide-modal' : '']">
  <div *ngIf="showOverlayBackground && !isMinimized" (click)="closeModalLoader(2, false)" class="pt-overlay-subtle pt-popup-overlay"></div>
  <div class="modal-target modal-type pt-dialog-context pt-popup" [ngClass]="{'minimized': isMinimized}">
    <section class="modal-container Auto_Popup {{classes}} {{formFormClassName}}">

      <dls-dialog>
        <dls-dialog-header *ngIf="!hideHeader">
          <i class="pt-icon type-icon {{iconName}}" *ngIf="iconName"></i>
          <span class="pt-title" *ngIf="typeText" [innerHtml]="typeText" translate></span>
          <span [ngClass]="titleCss ? titleCss : 'pt-title'" *ngIf="title" [innerHtml]="title" translate></span>

          <span class="pt-icon type-edit-btn icon__edit" *ngIf="showEditIcon" (click)="close(4, true)"></span>

          <span class="pt-icon close-icon pointer Pacs_icon_dls_tabMinimize" *ngIf="showMinimizeIcon" [ngClass]="{'readonly disabled': isMinimized}" (click)="toggleMinimize()"></span>
          <span class="pt-icon close-icon pointer Pacs_icon_dls_tabMaximize" *ngIf="showMinimizeIcon" [ngClass]="{'readonly disabled': !isMinimized}" (click)="toggleMinimize()"></span>

          <span class="pt-icon close-icon type-close-btn icon__cross" *ngIf="showCloseIcon" (click)="close(2, false)"></span>
          <span class="pt-icon close-btn icon__cross" (click)="close(2)" *ngIf="!typeText && !title && showCloseIcon"></span>
        </dls-dialog-header>

        <!-- Place holder for dynamic content populate here based on the modal type / component to load -->
        <ng-template #target></ng-template>

        <dls-dialog-footer class="modal-buttons-section" *ngIf="declineBtn || approveBtn || actionBtn">
          <gen-button class="Auto_Popup_Action_Button" *ngIf="actionBtn" (click)="close(3)"
                      [type]="'quite'"
                      [text]="actionBtn"></gen-button>
          <gen-button class="Auto_Popup_Cancel_Button" *ngIf="declineBtn" (click)="close(2, true)"
                      [type]="'quite'"
                      [text]="declineBtn"></gen-button>
          <gen-button class="Auto_Popup_Submit_Button" *ngIf="approveBtn" (click)="close(1)"
                      [type]="'primary'"
                      [text]="approveBtn"></gen-button>
        </dls-dialog-footer>
      </dls-dialog>
    </section>
  </div>
</div>
